// Kombinierter Modal Scroll Fix + Thumbnail-Navigation (NUR DESKTOP)
document.addEventListener('DOMContentLoaded', function() {
  const mediaGallery = document.querySelector('.product__media-wrapper');
  if (!mediaGallery) return;

  let scrollPosition = 0;

  // Modal öffnen
  document.addEventListener('click', function(e) {
    // ✅ Mobile komplett ausschließen
    if (window.innerWidth < 750) return;
    
    // ✅ Prüfen ob auf Modal-Trigger geklickt wurde (nicht auf umgebenden Container)
    const modalTrigger = e.target.closest('.product__media-toggle') ||
                         e.target.closest('button[data-open-media-modal]') ||
                         (e.target.closest('.product__media-item') && 
                          (e.target.tagName === 'IMG' || 
                           e.target.tagName === 'VIDEO' ||
                           e.target.tagName === 'MODEL-VIEWER' ||
                           e.target.classList.contains('product__media-toggle')));
    
    if (modalTrigger) {
      setTimeout(() => {
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Desktop-Verhalten
        Object.assign(document.documentElement.style, { overflow: 'hidden' });
        Object.assign(document.body.style, {
          overflow: 'hidden',
          position: 'fixed',
          width: '100%',
          top: `-${scrollPosition}px`
        });
        
        // Modal-Dialog scrollbar machen
        const modalDialog = document.querySelector('.product-media-modal__dialog');
        const modalContent = document.querySelector('.product-media-modal__content');
        
        if (modalDialog) {
          Object.assign(modalDialog.style, {
            overflowY: 'auto',
            overflowX: 'hidden',
            maxHeight: '100vh',
            scrollBehavior: 'smooth',
            webkitOverflowScrolling: 'touch',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '2rem'
          });
          modalDialog.scrollTop = 0;
        }
        
        if (modalContent) {
          Object.assign(modalContent.style, {
            overflow: 'visible',
            maxHeight: 'none',
            paddingTop: '0',
            marginTop: '0'
          });
        }

        // Thumbnails in Lightbox aktivieren
        const thumbnailSlider = document.querySelector('.thumbnail-list');
        if (thumbnailSlider) {
          thumbnailSlider.classList.add('thumbnail-list--in-lightbox');
          
          const thumbnails = thumbnailSlider.querySelectorAll('.thumbnail-list__item');
          thumbnails.forEach((thumb, index) => {
            if (!thumb.dataset.lightboxListener) {
              thumb.dataset.lightboxListener = 'true';
              thumb.addEventListener('click', function(e) {
                e.preventDefault();
                
                const modal = document.querySelector('.product-media-modal__dialog');
                const mainImages = modal?.querySelectorAll('.product-media-modal__content > *');
                
                if (mainImages && mainImages[index]) {
                  mainImages[index].scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center'
                  });
                }
              });
            }
          });
        }
      }, 10);
    }
  });
  
  // Modal schließen
  document.addEventListener('click', function(e) {
    // ✅ Mobile komplett ausschließen
    if (window.innerWidth < 750) return;
    
    const isCloseTrigger = e.target.closest('.product-media-modal__toggle') || 
                           e.target.id?.includes('ModalClose');
    
    if (isCloseTrigger) {
      ['overflow', 'position', 'width', 'top'].forEach(prop => {
        document.documentElement.style[prop] = '';
        document.body.style[prop] = '';
      });
      window.scrollTo(0, scrollPosition);
      
      const thumbnailSlider = document.querySelector('.thumbnail-list');
      if (thumbnailSlider) {
        thumbnailSlider.classList.remove('thumbnail-list--in-lightbox');
      }
    }
  });
});
